import { Fragment, useEffect, useState } from 'react';
import { FaArrowRightLong } from 'react-icons/fa6';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { checkScore, getRegistered } from '../../actions/warranty';
import Button from '../../components/ui/Button/Button';
import { Input } from '../../components/ui/Input/Input';
import RegisteredItem from '../../components/ui/RegisteredItem';
import { CheckBox } from '../../utils/components';
import { validateCase } from '../../utils/constants';
import CaseSteps from './components/CaseSteps';

const options = [{ yes: false, no: false }];

const Case = ({
  warranty: { loadingRegistered, registered, score, getScore },
  getRegistered,
  checkScore,
}) => {
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!getScore) checkScore('submit');
  }, [checkScore, getScore]);

  const [isRegistered, setRegistered] = useState(options);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    item: null,
    isForm: false,
  });
  const [items, setItem] = useState([]);

  const [required, setRequired] = useState({
    email: { filled: false, message: '' },
    item: { filled: false, message: '' },
  });

  const { email, item, isForm } = formData;

  useEffect(() => {
    setItem(registered.map((r) => false));
  }, [registered]);

  const changeRegistered = (name) => {
    const newRegistered = { yes: false, no: false };
    if (name) {
      newRegistered[name] = !isRegistered[name];
    }
    setRegistered(newRegistered);
  };

  const changeFormData = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const checkEmail = async (e) => {
    setStep(-1);
    const data = validateCase({ old: required, values: formData, step: -1 });
    setRequired(data.newValues);
    if (!data.preventChange) {
      const res = await getRegistered(email);
      if (!res) {
        setRequired({
          ...required,
          email: {
            filled: true,
            message:
              'A user with that email was not found. Please try again or fill in the standard form.',
          },
        });
      } else {
        setStep(0);
      }
    }
  };

  const selectItem = (e) => {
    const id = +e.currentTarget.getAttribute('data-id');
    const index = +e.currentTarget.getAttribute('data-index');
    if (id) {
      setFormData({
        ...formData,
        item: !items[index] ? registered.find((item) => item.id === id) : null,
      });
      setItem(
        items.map((item, i) => {
          if (i === index) {
            return !item;
          }
          return false;
        }),
      );
    }
  };

  const changeStep = (e) => {
    const index = +e.currentTarget.getAttribute('data-index');
    if (index) {
      if (index < step) {
        setStep(index);
        return;
      }

      const data = validateCase({ old: required, values: formData, step });
      setRequired(data.newValues);

      if (!data.preventChange) {
        setStep(index);
        if (index === 1) setFormData({ ...formData, isForm: true });
      }
    }
  };

  return (
    <div className='register-container'>
      <div className='register-steps-header'>
        <Link to='/' className='breadcrumbs-link'>
          Warranty
        </Link>
        <FaArrowRightLong className='register-header-icon' />
        PRODUCT ISSUE
      </div>
      <div className='case-container'>
        {isForm ? (
          <CaseSteps step={step} setStep={setStep} data={item ? item : {}} />
        ) : (
          <Fragment>
            <div className='case-box'>
              <h2 className='case-box-header'>
                Do you have registered products?
              </h2>
              <div className='case-box-options-list'>
                <label className='case-box-option'>
                  <CheckBox
                    checked={isRegistered.yes}
                    onChange={() => changeRegistered('yes')}
                    className='case-check-container'
                  />
                  Yes
                </label>
                <label className='case-box-option'>
                  <CheckBox
                    checked={isRegistered.no}
                    onChange={() => changeRegistered('no')}
                    className='case-check-container'
                  />
                  No
                </label>
              </div>
            </div>
            <div
              className='case-box-email-box'
              style={{
                display: isRegistered.yes ? '' : 'none',
              }}
            >
              <div className='case-box-email'>
                <div className='case-email-input'>
                  <Input
                    label='Enter Your Email'
                    type='email'
                    name='email'
                    value={email}
                    onChange={changeFormData}
                    error={required.email.message}
                    className='case-form__input'
                    required
                  />
                </div>
                <Button
                  onClick={checkEmail}
                  disabled={loadingRegistered || score < 0.5 ? true : false}
                >
                  CHECK MY ITEMS
                </Button>
              </div>
            </div>
            <div
              style={{
                display: isRegistered.no || required.email.filled ? '' : 'none',
              }}
              className='case-register-btn'
            >
              <Button
                disabled={loadingRegistered || score < 0.5 ? true : false}
                onClick={() => history.push('/register/')}
              >
                FILL IN THE FORM
              </Button>
            </div>
            <div>
              {!isRegistered.no && (
                <div className='case-items'>
                  {loadingRegistered ? (
                    <div>Loading...</div>
                  ) : (
                    registered.map((r, i) => (
                      <RegisteredItem
                        key={`item-row-${i}`}
                        product={r}
                        index={i}
                        selectedItem={item}
                        isChecked={items[i] ? items[i] : false}
                        onSelectItem={selectItem}
                      />
                    ))
                  )}
                </div>
              )}
              <div className='case-form-btns'>
                <p
                  className='case-form-btns-error'
                  style={{ display: required.item.filled ? '' : 'none' }}
                >
                  Please, select an item
                </p>
              </div>
            </div>
            {registered.length > 0 && !isRegistered.no && (
              <div className='case-next-button'>
                <Button data-index='1' onClick={changeStep}>
                  NEXT
                </Button>
              </div>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  warranty: state.warranty,
});

export default connect(mapStateToProps, { getRegistered, checkScore })(Case);
